<template>
    <div class="border-t last:border-b py-2" data-cy="card_profile_address_tax_item">
        <div class="font-bold text-lg" v-if="address.personType == 'company'" data-cy="text_profile_address_tax_item_name">
            {{address.companyName}}
        </div>
        <div class="font-bold text-lg" v-else data-cy="text_profile_address_tax_item_name">
            {{address.firstname}} {{address.lastname}}
        </div>
        <div class="text-gray-400" data-cy="text_profile_address_tax_item_address">
            {{address.address}}
            {{address.subDistrictName}}
            {{address.districtName}}
            {{address.provinceName}}
            {{address.zipcode}}
        </div>
        <div class="pt-2">
            <button class="bg-yellow-500 text-white py-1 px-4 rounded-md text-sm mr-2" @click="onEditAddress()" data-cy="btn_profile_address_tax_item_edit">Edit</button>
            <button class="bg-red-700 text-white py-1 px-4 rounded-md text-sm" @click="onDeleteAddress()" data-cy="btn_profile_address_tax_item_delete">Delete</button>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
/**
 * @event onDeleteSuccess
 */
export default {
    name: "TaxAddressItem",
    mixins: [LocaleMixin],
    props: {
        address: Object,
    },
    methods: {
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
